import { Text } from '@mantine/core';

interface Props {
  label: string;
  children?: React.ReactNode; // Add children to the interface
  fromTradeDocument?: boolean; // Optional prop to specify if it's from a trade document
}

export function TextLabelInput({ label, children, fromTradeDocument }: Props) {
  const labelClass = fromTradeDocument ? 'documentTradeEntryLabel' : 'dataEntryLabel';
  return (
    <>
      <Text className={labelClass}>{label}:</Text>
      {typeof children === 'string' ? <Text className="dataEntryInput">{children}</Text> : children}
    </>
  );
}
